const USER_CENTER_PROFILE_TAB = 'profile';
const USER_CENTER_PROJECTS_TAB = 'projects';
const USER_CENTER_MATERIALS_TAB = 'resource';
const USER_CENTER_DEFAULT_TAB = USER_CENTER_PROFILE_TAB;

const USER_CENTER_ENTRY_TABS = [
    USER_CENTER_PROFILE_TAB,
    USER_CENTER_PROJECTS_TAB,
    USER_CENTER_MATERIALS_TAB
];

const normalizeUserCenterTab = tab => (
    USER_CENTER_ENTRY_TABS.indexOf(tab) === -1 ? USER_CENTER_DEFAULT_TAB : tab
);

export {
    USER_CENTER_DEFAULT_TAB,
    USER_CENTER_ENTRY_TABS,
    USER_CENTER_MATERIALS_TAB,
    USER_CENTER_PROFILE_TAB,
    USER_CENTER_PROJECTS_TAB,
    normalizeUserCenterTab
};
